import type { RootState } from '@/store';

export const selectDeskPaymentRegistry = (state: RootState) =>
  state.deskPaymentRegistry.registry;

export const selectFollowedDeskPaymentIntentCounts = (state: RootState) =>
  state.deskPaymentRegistry.followedPaymentIntentCounts;
